import { render, staticRenderFns } from "./Allergens.vue?vue&type=template&id=8d1db82a"
import script from "./Allergens.vue?vue&type=script&lang=ts"
export * from "./Allergens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports